module.exports = __webpack_public_path__ + "static/Salesforce-Iphone-19011dfe2cd37dc8fca5ab0368129abe.mp4";